module.exports = __webpack_public_path__ + "static/media/product (2).e7ca89d2.svg";